import { Component } from '@angular/core';

@Component({
  selector: 'qas-contact-us-about-product',
  templateUrl: './contact-us-about-product.component.html',
  styleUrls: [ './contact-us-about-product.component.scss' ]
})
export class ContactUsAboutProductComponent {
}
